<template>
  <div>
    <Navbar style="z-index: 999;"/>
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Jovem Aprendiz</h1>
          <vs-divider />
          <p style="font-size: 0.7em">
            * Clique no botão de seta para avançar e realizar ações com o aluno.
          </p>
        </header>

        <div class="table-search-wrapper" v-if="apprenticeList && apprenticeList.length > 0">
          <div class="search-input-group">
            <vs-input
              type="text"
              v-model="searchTerm"
              placeholder="Pesquisar Aluno ou RA..."
            />
            <vs-button
              icon="search"
              type="flat" 
            />
          </div>
          
          <template v-if="apprenticeList && apprenticeList.length > 0">
            <vs-table
              class="pd-table"
              :max-items="pageSize"
              :data="filteredList"
              pagination
              description
              :description-items="descriptionItems"
              description-title="Registros"
              description-connector="de"
              description-body="Mostrar"
            >
              <template slot="thead">
                <th>Ação</th>
                <th @click="sortData('CODFILIAL')">Filial</th>
                <th @click="sortData('CURSO')">Curso</th>
                <th @click="sortData('RA')">RA</th>
                <th @click="sortData('ALUNO')">Aluno</th>                
                <th @click="sortData('DTMATRICULA')">Data Matrícula</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" class="pointer" :key="indextr" v-for="(tr, indextr) in data">
                  
                  <vs-td>
                    <vs-button 
                      @click="goToDetails(data[indextr])" 
                      color="danger" 
                      type="filled" 
                      icon="arrow_forward" 
                    />
                  </vs-td>

                  <vs-td>
                    <div class="b__small">
                      {{ data[indextr].CODFILIAL }}
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="b__important">
                      {{ data[indextr].CURSO }}
                    </div>
                  </vs-td>                  
                  
                  <vs-td>
                    <div class="b__important">
                      {{ data[indextr].RA }}
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="b__important">
                      {{ data[indextr].ALUNO }}
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="b__important">
                        {{ data[indextr].DTMATRICULA | moment }}
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </template>
        </div>

        <vs-alert color="danger" icon="new_releases" v-else>
          <b>Sem resultados para serem mostrados no momento.</b>
        </vs-alert>

      </section>
    </div>
  </div>
</template>

<script>
import sortBy from "sort-by";
import Mailing from "../services/mailing";
import { getLoginDataFromStorage } from "../helpers";
import moment from "moment";

export default {
  name: "Apprentice",
  data: () => ({
    searchTerm: "",
    descriptionItems: [10, 50, 100],
    apprenticeList: [],
    error: null,
    sortProperty: "ALUNO", 
    sortOrder: "asc", 
    page: 1, 
    pageSize: 10, 
  }),
  computed: {
    filteredList() {
      if (!this.searchTerm) {
        return this.apprenticeList;
      }
      const lowerSearch = this.searchTerm.toLowerCase();
      return this.apprenticeList.filter((item) => {
        return (
          (item.ALUNO && item.ALUNO.toLowerCase().includes(lowerSearch)) ||
          (item.RA && String(item.RA).includes(lowerSearch))
        );
      });
    }
  },
  created() {
    this.userData = getLoginDataFromStorage();
  },
  mounted() {
    this.fetchApprentices();
  },
  methods: {
    sortData(property) {
      if (this.sortProperty === property) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortProperty = property;
        this.sortOrder = "asc";
      }
      this.apprenticeList.sort(
        sortBy(this.sortOrder === "asc" ? property : `-${property}`)
      );
    },

    fetchApprentices() {
      this.$vs.loading({ color: "danger" });

      new Mailing()
        .getApprentices()
        .then((response) => {
          if (response && response.data) {
            this.apprenticeList = Array.isArray(response.data) ? response.data : [response.data];
          }
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
            this.$vs.notify({
              title: 'Erro ao buscar dados',
              text: this.error,
              color: 'danger',
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    goToDetails(studentData) {
      this.$router.push({ 
        path: '/young-apprentice', 
        query: { 
            ra: studentData.RA, 
            name: studentData.ALUNO, 
            idHabilitacao: studentData.IDHABILITACAOFILIAL, 
            idPerLet: studentData.IDPERLET,
            codColigada: studentData.CODCOLIGADA,
            filial: studentData.CODFILIAL,
            curso: studentData.CURSO
        } 
      });
    }
  },
  filters: {
    moment: function (date) {
      if (!date) return "-";
      moment.locale("pt-br");
      if (String(date).includes('/')) {
        return date; 
      }
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.table-search-wrapper {
  position: relative;
  padding-top: 30px; 
}

.search-input-group {
  position: absolute;
  top: -25px;
  right: 15px;
  z-index: 10;
  width: 250px;
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}

.search-input-group .vs-inputx {
  border: none !important;
  flex-grow: 1;
  box-shadow: none !important;
}
.search-input-group .vs-inputx input {
    width: 100%;
}

.search-input-group .vs-button-flat {
  border-left: 1px solid #dcdcdc;
  border-radius: 0;
}

.search-input-group:focus-within {
  box-shadow: none !important;
}

.b__important {
  font-weight: bold;
}

.b__small {
  font-size: 0.85em;
  color: gray;
}
</style>